module.exports = __webpack_public_path__ + "img/Ora-Ani_Bruecke_kl.22d97e4e.jpg";